export const normalizeBookings = (bookingData, fallback = []) => {
  if (Array.isArray(bookingData)) return bookingData;
  if (bookingData) return [bookingData];
  return fallback;
};

export const filterByBookingTypes = (events, bookingTypes = []) => {
  const allowedTypeIds = new Set((bookingTypes || []).map((val) => Number(val.id)));
  if (allowedTypeIds.size === 0) {
    return events || [];
  }
  return (events || []).filter((event) => {
    const source = String(event?.source || "").toLowerCase();
    const isGoogleEvent = source.includes("google");
    const isQuickBooking =
      event?.bookingTypeId == null ||
      Boolean(event?.quickSource) ||
      Boolean(event?.quickTitle);
    if (isGoogleEvent) return true;
    if (isQuickBooking) return true;
    return allowedTypeIds.has(Number(event.bookingTypeId));
  });
};
